/* ENDURRAD — STILE APP
   Barra mobile come la tab bar dell'app: sempre visibile ed evidenzia in
   blu la voce corrispondente alla pagina aperta. File aggiunto: sopravvive agli
   aggiornamenti del tema. Caricato da snippets/endurrad-app-stile.liquid. */
(function () {
  function voceAttiva(path) {
    if (path === '/' || /^\/[a-z]{2}(-[a-z]{2})?\/?$/.test(path)) return 'home';
    if (path.indexOf('/search') !== -1 || path.indexOf('risultati-di-ricerca') !== -1) return 'search';
    if (path.indexOf('/cart') !== -1) return 'cart';
    if (path.indexOf('/account') !== -1) return 'account';
    if (path.indexOf('/pages/marche-moto') !== -1 || path.indexOf('-modelli-accessori') !== -1) return 'moto';
    return null;
  }

  function segna() {
    var dock = document.querySelector('.mobile-dock');
    if (!dock) return;
    // Barra sempre visibile come nell'app: con la classe «active» sulla
    // sezione il tema sposta sopra la barra i suoi elementi fissi
    // (pulsante d'acquisto, filtri delle collezioni).
    var sezione = dock.closest('.mobile-dock-section');
    if (sezione) sezione.classList.add('active');
    var voce = voceAttiva(window.location.pathname);
    if (!voce) return;
    var el = null;
    if (voce === 'home') el = dock.querySelector('a.dock__item[href="/"], a.dock__item[href$="/"]');
    if (voce === 'search') el = dock.querySelector('.dock__item[href*="search"], .dock__item[aria-controls*="Search"], .dock__item[aria-controls*="search"]');
    if (voce === 'cart') el = dock.querySelector('.dock__item[aria-controls="CartDrawer"]');
    if (voce === 'account') el = dock.querySelector('shopify-account.dock__item');
    if (voce === 'moto') el = dock.querySelector('a.dock__item[href*="marche-moto"]');
    if (el) {
      el.classList.add('erd-dock-attiva');
      el.setAttribute('aria-current', 'page');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', segna);
  } else {
    segna();
  }
})();
